module.exports = __webpack_public_path__ + "media/images/icon-consultation-145ffad62f6a9a7c61ac071b30e1ebfa.png";